import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IAccountRequestService } from './../';
let template = require('./deny-message-dialog.html');

class DenyMessageDialogComponent extends ComponentRegistration {

    constructor() {
        super('denyMessageDialog', {
            controller: DenyMessageDialogController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IDenyMessageDialogController {

}

class DenyMessageDialogController implements IDenyMessageDialogController {
    private static $inject: Array<string> = ['$mdDialog'];
    private email: string;

    constructor(private $mdDialog: ng.material.IDialogService) {

    }

    public $onInit() {
    }

    public onCancel() {
        this.$mdDialog.hide({
            send: false
        });
        this.email = "";
    }

    public onSend() {
        this.$mdDialog.hide({
            send: true,
            message: this.email
        });

    }
}

let denyMsgDiaComponent = new DenyMessageDialogComponent();
export default denyMsgDiaComponent;
export { denyMsgDiaComponent as DenyMessageDialogComponent, IDenyMessageDialogController, DenyMessageDialogController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/pending-approval/deny-message-dialog.ts